module.exports = __webpack_public_path__ + "static/media/Floor001-01.ae2c03c4.jpg";